import { type ComponentType, type SVGProps } from 'react';
import SolarBoxLinear from 'components/icons/SolarBoxLinear';
import SolarClipboardCheckOutline from 'components/icons/SolarClipboardCheckOutline';
import SolarSunriseLinear from 'components/icons/SolarSunriseLinear';
import SvgDollar from 'components/svg/SvgDollar';

export type SettingsGroup = 'currency' | 'warehouse' | 'objects' | 'tasks';

export type GroupConfig = {
    key: SettingsGroup;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const GROUPS: GroupConfig[] = [
    { key: 'currency', Icon: SvgDollar },
    { key: 'warehouse', Icon: SolarBoxLinear },
    { key: 'objects', Icon: SolarSunriseLinear },
    { key: 'tasks', Icon: SolarClipboardCheckOutline },
];

export const isSettingsGroup = (value: string | null): value is SettingsGroup =>
    value === 'currency' || value === 'warehouse' || value === 'objects' || value === 'tasks';
